import { styled } from 'styled-components';
import { CheckIcon } from '../../assets/svg';

const ButtonCheck = ({ label, checked, handleChange }) => {
  return (
    <Label htmlFor={label} className={checked && 'checked'}>
      {label}
      <Check>
        <CheckIcon />
      </Check>
      <CheckboxInput
        id={label}
        type='checkbox'
        defaultChecked={checked}
        onChange={evt => handleChange(evt.target.checked)}
      />
    </Label>
  );
};

const CheckboxInput = styled.input`
  appearance: none;
  display: none;
`;

const Check = styled.span`
  height: ${props => props.theme.sizeH5};
  width: ${props => props.theme.sizeH5};
  min-height: ${props => props.theme.sizeH5};
  min-width: ${props => props.theme.sizeH5};
  margin: -2px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: transparent;

  border: 2px solid ${props => props.theme.mutedColor};
  border-radius: ${props => props.theme.borderFull};

  transition: ${props => {
    return ['background-color', 'border-color', 'color']
      .map(style => `${style} ${props.theme.transition}`)
      .join(',');
  }};

  svg {
    height: ${props => props.theme.sizeSmall};
    width: ${props => props.theme.sizeSmall};
    min-height: ${props => props.theme.sizeSmall};
    min-width: ${props => props.theme.sizeSmall};
    color: ${props => props.theme.backgroundColor};
    transition: color ${props => props.theme.transition};
  }
`;

const Label = styled.label`
  padding: ${props => props.theme.paddingMd};
  padding-right: ${props => props.theme.sizeSm};

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: ${props => props.theme.sizeSmall};
  font-weight: ${props => props.theme.headerWeight};
  letter-spacing: ${props => props.theme.headerSpacing};
  text-transform: uppercase;
  color: ${props => props.theme.mutedColor};

  background-color: ${props => props.theme.backgroundColor};

  border: none;
  border-radius: ${props => props.theme.borderFull};

  cursor: pointer;

  transition: ${props => {
    return ['scale', 'background-color', 'border-color', 'color', 'box-shadow']
      .map(style => `${style} ${props.theme.transition}`)
      .join(',');
  }};

  &:hover {
    color: ${props => props.theme.textColor};

    ${Check} {
      border-color: ${props => props.theme.textColor};
    }
  }

  &:active {
    scale: 0.99;
    box-shadow: 0 0 0 4px ${props => props.theme.foregroundColor},
      0 0 0 6px ${props => props.theme.brand + props.theme.clear50};
  }

  &.checked {
      background-color: ${props => props.theme.brand};
      color: ${props => props.theme.backgroundColor};
  
      ${Check} {
        background-color: ${props => props.theme.backgroundColor};
        border-color: ${props => props.theme.backgroundColor};
  
        svg {
          color: ${props => props.theme.brand};
        }
      }
    }

  // Ignore for now, Firefox does not support :has selector
  // &:has(${CheckboxInput}:checked) {
  //   background-color: ${props => props.theme.brand};
  //   color: ${props => props.theme.backgroundColor};

  //   ${Check} {
  //     background-color: ${props => props.theme.backgroundColor};
  //     border-color: ${props => props.theme.backgroundColor};

  //     svg {
  //       color: ${props => props.theme.brand};
  //     }
  //   }
  // }
`;

export default ButtonCheck;
